import axios from "axios";
import qs from "qs"

const state = {
  subscriptionPlans: [],
  subscriptionPlan: {},
  loading: false,
  subscriptionTypes: [],
};


const getters = {
  allSubscriptionPlans: (state) => state.subscriptionPlans,
  subscriptionPlanData: (state) => state.subscriptionPlan,
  loading: (state) => state.loading,
  allSubscriptionTypes: (state) => state.subscriptionTypes,
  subscriptionLabels: () => ({
    ['GENERAL']: 'Genel',
    ['PLUS']: 'Plus',
    ['BASIC']: 'Basic'
  }),
  codeTypeLabels: () => ({
    ['General']: 'Genel',
    ['Unique']: 'Unique Kod',
  })
};

const actions = {
  getSubscriptionPlans({ commit }, query) {
    commit('setLoading', true)
    const queryString = qs.stringify({
      page: query.pageNumber,
      size: query.pageSize,
      subscriptionType: query.subscriptionPlan
    },
      {
        skipNulls: true,
        filter: (prefix, value) => (value !== '' ? value : undefined),
      });
    return axios
      .get(
        `/api/subscription/get-subscription-plans?${queryString}`
      )
      .then((response) => {
        commit("setSubscriptionPlans", response.data.payload.items);
        commit("setLoading", false);

        return response.data.payload;
      });
  },
  getSubscriptionPlan({ commit }, subscriptionPlan) {
    axios
      .get(`/api/subscription/get-subscription-plan/${subscriptionPlan.id}`)
      .then((response) => {
        commit("setSubscriptionPlan", response.data.payload);
        response.data.payload;
      });
  },
  updateSubscriptionPlanAmount({ commit }, subscriptionPlan) {
    let subscriptionPlanData = {
      amount: subscriptionPlan.amount,
    };

    return axios
      .put(`/api/subscription/update-subscription-plan/${subscriptionPlan.id}`, subscriptionPlanData)
      .then((response) => {

        console.log("response", response);
        return response.data;
      });
  },

  getSubscriptionTypes({ commit }) {
    return axios
      .get(`/api/public/get-enum/SubscriptionType`)
      .then((response) => {
        commit("setSubscriptionTypes", response.data.payload);
        return response.data.payload;
      });
  },
};

const mutations = {
  setSubscriptionPlans: (state, subscriptionPlans) => {
    state.subscriptionPlans = subscriptionPlans;
  },
  setSubscriptionPlan: (state, subscriptionPlan) => {
    state.subscriptionPlan = subscriptionPlan;
  },
  setLoading(state, value) {
    state.loading = value;
  },
  setSubscriptionTypes(state, subscriptionTypes) {
    state.subscriptionTypes = subscriptionTypes;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};